import { render, staticRenderFns } from "./resumen_compra.vue?vue&type=template&id=0ad6719e"
import script from "./resumen_compra.vue?vue&type=script&lang=js"
export * from "./resumen_compra.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports